import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=dca862c0&scoped=true&"
import script from "./Catalog.vue?vue&type=script&lang=ts&"
export * from "./Catalog.vue?vue&type=script&lang=ts&"
import style0 from "./Catalog.vue?vue&type=style&index=0&id=dca862c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca862c0",
  null
  
)

export default component.exports